(function () {
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function money(c){ return '$' + (c/100).toFixed(2).replace(/\.00$/, ''); }
  function piPickSrc(img, target){
    var ss = img.getAttribute('srcset');
    if (ss){
      var best=null, bestd=1e9;
      ss.split(',').forEach(function(part){
        var m=part.trim().match(/(\S+)\s+(\d+)w/);
        if(m){ var w=parseInt(m[2],10); var d=Math.abs(w-target); if(d<bestd){bestd=d;best=m[1];} }
      });
      if(best) return best;
    }
    return img.currentSrc || img.src;
  }

  var overlay;
  function ensureOverlay(){
    if (overlay) return overlay;
    overlay = document.createElement('div'); overlay.id='pi-qa-overlay'; overlay.setAttribute('aria-hidden','true');
    overlay.innerHTML='<div class="pi-qa" role="dialog" aria-modal="true"><button class="pi-qa__close" aria-label="Close">&times;</button><div class="pi-qa__body"></div></div>';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function(e){ if(e.target===overlay) closeQA(); });
    overlay.querySelector('.pi-qa__close').addEventListener('click', closeQA);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeQA(); });
    return overlay;
  }
  function openQA(){ ensureOverlay().classList.add('pi-open'); overlay.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function closeQA(){ if(overlay){ overlay.classList.remove('pi-open'); overlay.setAttribute('aria-hidden','true'); document.body.style.overflow=''; } }

  function quickAdd(handle){
    if (window.piIsLocked && window.piIsLocked(handle)) { window.location.href = '/products/'+handle; return; }
    ensureOverlay();
    var body = overlay.querySelector('.pi-qa__body');
    body.innerHTML = '<div class="pi-qa__loading">Loading…</div>';
    openQA();
    fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){ renderPicker(p, body); }).catch(function(){ body.innerHTML='<div class="pi-qa__loading">Unavailable</div>'; });
  }
  window.piQuickAdd = quickAdd;

  function renderPicker(p, body){
    var img = (p.featured_image || (p.images && p.images[0]) || '');
    if (img && img.indexOf('//')===0) img='https:'+img;
    var selected = {};
    var h = '<div class="pi-qa__head"><div class="pi-qa__img">'+(img?'<img src="'+img+'" alt="">':'')+'</div>';
    h += '<div class="pi-qa__meta"><div class="pi-qa__type">'+(p.type||'')+'</div><div class="pi-qa__title">'+p.title+'</div><div class="pi-qa__price">'+money(p.price)+'</div></div></div>';
    h += '<div class="pi-qa__options">';
    p.options.forEach(function(opt, oi){
      h += '<div class="pi-qa__opt"><div class="pi-qa__opt-label">'+opt.name+'</div><div class="pi-qa__pills">';
      opt.values.forEach(function(val){ h += '<button type="button" class="pi-qa__pill" data-oi="'+oi+'" data-val="'+encodeURIComponent(val)+'">'+val+'</button>'; });
      h += '</div></div>';
    });
    h += '</div><button type="button" class="pi-qa__add" disabled>Select options</button>';
    body.innerHTML = h;
    function resolve(){
      var chosen = p.options.map(function(_,i){ return selected[i]; });
      if (chosen.some(function(v){ return v==null; })) return null;
      return p.variants.find(function(v){ return v.options.every(function(ov,i){ return ov===chosen[i]; }); });
    }
    function update(){
      var add = body.querySelector('.pi-qa__add'); var v = resolve();
      if (v && v.available){ add.disabled=false; add.textContent='Add to Bag'; add.dataset.vid=v.id; }
      else if (v){ add.disabled=true; add.textContent='Sold Out'; }
      else { add.disabled=true; add.textContent='Select options'; }
    }
    body.querySelectorAll('.pi-qa__pill').forEach(function(pill){
      pill.addEventListener('click', function(){
        var oi=+pill.dataset.oi; selected[oi]=decodeURIComponent(pill.dataset.val);
        body.querySelectorAll('.pi-qa__pill[data-oi="'+oi+'"]').forEach(function(x){ x.classList.remove('is-sel'); });
        pill.classList.add('is-sel'); update();
      });
    });
    body.querySelector('.pi-qa__add').addEventListener('click', function(){
      var vid=this.dataset.vid; if(!vid) return; this.disabled=true; this.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:1})}).then(function(r){return r.json();}).then(function(item){ renderAdded(p,img,item,body); }).catch(function(){});
    });
    p.options.forEach(function(opt,oi){ if(opt.values.length===1){ selected[oi]=opt.values[0]; var pl=body.querySelector('.pi-qa__pill[data-oi="'+oi+'"]'); if(pl) pl.classList.add('is-sel'); } });
    update();
  }

  function renderAdded(p,img,item,body){
    var price = (item && item.final_price!=null) ? item.final_price : p.price;
    body.innerHTML = '<div class="pi-qa__added-label">Added to Bag</div>'
      + '<div class="pi-qa__head"><div class="pi-qa__img">'+(img?'<img src="'+img+'">':'')+'</div>'
      + '<div class="pi-qa__meta"><div class="pi-qa__title">'+p.title+'</div><div class="pi-qa__price">'+money(price)+'</div></div></div>'
      + '<div class="pi-qa__ctas"><a class="pi-qa__btn pi-qa__btn--ghost" href="/cart">View Bag</a><a class="pi-qa__btn pi-qa__btn--solid" href="/checkout">Checkout</a></div>';
  }

  function piFeedHTML(products){
    var cards = products.map(function(p){
      var i1 = (p.images && p.images[0] && p.images[0].src) || '';
      var i2 = (p.images && p.images[1] && p.images[1].src) || '';
      var vp = (p.variants || []).map(function(v){ return parseFloat(v.price); }).filter(function(n){ return !isNaN(n); });
      var price = vp.length ? ('$' + Math.min.apply(null, vp).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })) : '';
      var title = (p.title || '').replace(/"/g, '');
      var cat = (p.product_type || '').replace(/"/g, '');
      return '<div class="pi-feed__card">'
        + '<a class="pi-feed__media" href="/products/'+p.handle+'">'
        + (i1 ? '<img class="pi-feed__img pi-feed__img--1" src="'+i1+'&width=700" alt="'+title+'" loading="lazy">' : '')
        + (i2 ? '<img class="pi-feed__img pi-feed__img--2" src="'+i2+'&width=700" alt="" aria-hidden="true" loading="lazy">' : '')
        + '<span class="pi-feed__tag"></span>'
        + '<button class="pi-feed__add" type="button" data-handle="'+p.handle+'" aria-label="Quick add"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>'
        + '</a>'
        + '<a class="pi-feed__info" href="/products/'+p.handle+'">'
        + (cat ? '<span class="pi-feed__cat">'+cat+'</span>' : '')
        + '<span class="pi-feed__name">'+(p.title||'')+'</span><span class="pi-feed__price">'+price+'</span></a>'
        + '</div>';
    }).join('');
    var arrow = function(dir){ return '<button type="button" class="pi-feed__arrow pi-feed__arrow--'+dir+'" data-dir="'+(dir==='prev'?-1:1)+'" aria-label="'+(dir==='prev'?'Previous':'Next')+' products"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="'+(dir==='prev'?'M15 5l-7 7 7 7':'M9 5l7 7-7 7')+'"/></svg></button>'; };
    return '<div class="pi-feed"><div class="pi-feed__head"><h2 class="pi-feed__title">New Arrivals</h2><div class="pi-feed__ctrl">'+arrow('prev')+arrow('next')+'<a class="pi-feed__all" href="/collections/pearled-ivory">Shop All</a></div></div><div class="pi-feed__track">'+cards+'</div></div>';
  }
  function piFeedArrows(track){
    var feed = track.closest('.pi-feed'); if (!feed) return;
    var max = track.scrollWidth - track.clientWidth;
    feed.querySelectorAll('.pi-feed__arrow').forEach(function(b){
      var d = +b.getAttribute('data-dir');
      b.disabled = d < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2;
    });
    feed.classList.toggle('pi-feed--scrolls', max > 2);
  }
  function piWireTrack(track){
    if (track.__piScroll) return; track.__piScroll = true;
    var feed = track.closest('.pi-feed');
    if (feed) feed.querySelectorAll('.pi-feed__arrow').forEach(function(b){
      b.addEventListener('click', function(e){
        e.preventDefault();
        var card = track.querySelector('.pi-feed__card');
        var step = card ? (card.getBoundingClientRect().width + 14) * Math.max(1, Math.floor(track.clientWidth / (card.getBoundingClientRect().width + 14))) : track.clientWidth * 0.9;
        track.scrollBy({ left: step * (+b.getAttribute('data-dir')), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', function(){ piFeedArrows(track); }, { passive: true });
    window.addEventListener('resize', function(){ piFeedArrows(track); });
    track.querySelectorAll('img').forEach(function(im){ im.setAttribute('draggable', 'false'); im.addEventListener('load', function(){ piFeedArrows(track); }); });
    /* Click-and-drag with a mouse (desktop). Touch already swipes natively. */
    var down = false, moved = false, sx = 0, sl = 0;
    track.addEventListener('pointerdown', function(e){
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest && e.target.closest('button')) return;
      down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
    });
    window.addEventListener('pointermove', function(e){
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 6){ moved = true; track.classList.add('is-dragging'); }
      if (moved){ track.scrollLeft = sl - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function(){ if (!down) return; down = false; setTimeout(function(){ track.classList.remove('is-dragging'); }, 0); });
    track.addEventListener('click', function(e){ if (moved){ e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', function(e){ e.preventDefault(); });
    piFeedArrows(track);
  }
  function piWireFeed(){
    document.querySelectorAll('.pi-feed__track').forEach(piWireTrack);
    document.querySelectorAll('.pi-feed__add').forEach(function(btn){
      if (btn.__piWired) return; btn.__piWired = true;
      btn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); if (window.piQuickAdd) window.piQuickAdd(btn.getAttribute('data-handle')); });
    });
  }
  function piDenimVideoHTML(){
    return '<div class="pi-denim-video">'
      + '<video class="pi-denim-video__media" autoplay muted loop playsinline preload="auto">'
      + '<source src="https://cdn.shopify.com/videos/c/vp/4f9b1040e9e347c99aad77abccb95bf6/4f9b1040e9e347c99aad77abccb95bf6.HD-1080p-7.2Mbps-87364621.mp4" type="video/mp4">'
      + '<source src="https://cdn.shopify.com/videos/c/vp/4f9b1040e9e347c99aad77abccb95bf6/4f9b1040e9e347c99aad77abccb95bf6.HD-720p-4.5Mbps-87364621.mp4" type="video/mp4">'
      + '</video>'
      + '<div class="pi-denim-video__head"><h2 class="pi-denim-video__title">Denim</h2></div>'
      + '<a class="pi-denim-video__cta" href="/collections/denim">Shop Denim <span aria-hidden="true">&#8594;</span></a>'
      + '</div>';
  }
  function piPlayDenim(){
    document.querySelectorAll('.pi-denim-video video').forEach(function(v){
      if (v.__piPlay) return; v.__piPlay = true;
      v.muted = true; v.loop = true; v.setAttribute('playsinline',''); v.setAttribute('muted','');
      v.addEventListener('ended', function(){ v.currentTime = 0; var p=v.play(); if(p&&p.catch) p.catch(function(){}); });
      var p0=v.play(); if(p0&&p0.catch) p0.catch(function(){});
    });
    if (!window.__piDenimKeeper){
      window.__piDenimKeeper = true;
      setInterval(function(){
        document.querySelectorAll('.pi-denim-video video').forEach(function(v){
          var r = v.getBoundingClientRect();
          if (v.paused && r.bottom > 0 && r.top < (window.innerHeight || 0)){ v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function(){}); }
        });
      }, 1200);
    }
  }
  function piColTabs(){
    if (!/\/collections\//.test(location.pathname)) return;
    if (document.querySelector('.pi-coltabs')) return;
    var allLinks = document.querySelectorAll('.menu-drawer__menu a[href*="/collections/"]');
    var seen = {}, links = [];
    Array.prototype.forEach.call(allLinks, function(a){
      if (a.classList.contains('pi-cat-link')) return;
      var name = (a.textContent||'').replace(/\s+/g,' ').trim();
      var href = a.getAttribute('href');
      if (!name || !href) return;
      if (/^(home|shop|about|collaborations)$/i.test(name)) return;
      if (seen[href]) return; seen[href] = 1;
      links.push({ name:name, href:href });
    });
    if (!links.length) return;
    var cur = (location.pathname.split('/collections/')[1] || '').split('/')[0].split('?')[0];
    var html = '<div class="pi-coltabs">';
    links.forEach(function(c){
      var seg = c.href.split('/collections/')[1] || '';
      var handle = seg.split('/')[0].split('?')[0];
      var label = c.name;
      html += '<a class="pi-coltab'+(handle===cur?' is-active':'')+'" href="'+c.href+'">'+label+'</a>';
    });
    html += '</div>';
    var mc = document.querySelector('#MainContent');
    if (mc){ var holder = document.createElement('div'); holder.innerHTML = html; mc.insertBefore(holder.firstChild, mc.firstChild); }
  }
  function piOpenOmnisend(){ window.omnisend = window.omnisend || []; window.omnisend.push(['openForm', '69ce5835ef007dd932e592bf']); }
  function piSubscribeHook(){
    function tag(){
      document.querySelectorAll('.announcement-bar__message, .announcement-bar a, .announcement-bar p, .announcement-bar span').forEach(function(el){
        if (/subscribe\s*&\s*save/i.test((el.textContent||'')) && (el.textContent||'').length < 40){ el.id='pi-subscribe-offer'; el.classList.add('pi-subscribe-offer'); el.style.cursor='pointer'; }
      });
    }
    tag(); setTimeout(tag, 1500); setTimeout(tag, 4000);
    if (!window.__piSubBound){
      window.__piSubBound = true;
      document.addEventListener('click', function(e){
        var t = e.target && e.target.closest ? e.target.closest('.pi-subscribe-offer, #pi-subscribe-offer') : null;
        if (!t){
          var amb = e.target && e.target.closest ? e.target.closest('.announcement-bar__message, .announcement-bar a') : null;
          if (amb && /subscribe\s*&\s*save/i.test(amb.textContent||'')) t = amb;
        }
        if (t){ e.preventDefault(); e.stopPropagation(); piOpenOmnisend(); }
      }, true);
    }
  }
  function piPromo(){
    if (document.getElementById('pi-promo')) return;
    try { if (sessionStorage.getItem('pi-promo-dismissed')==='1') return; } catch(e){}
    var el = document.createElement('div'); el.className='pi-promo'; el.id='pi-promo';
    el.innerHTML = '<button class="pi-promo__btn" type="button">Get 10% Off</button><button class="pi-promo__x" type="button" aria-label="Dismiss">&times;</button>';
    document.body.appendChild(el);
    el.querySelector('.pi-promo__btn').addEventListener('click', function(){ piOpenOmnisend(); });
    el.querySelector('.pi-promo__x').addEventListener('click', function(ev){ ev.stopPropagation(); el.classList.add('pi-hide'); try{ sessionStorage.setItem('pi-promo-dismissed','1'); }catch(e){} });
  }
  function piPdpDots(){
    if (!/\/products\//.test(location.pathname)) return;
    var sc = document.querySelector('.product__media-wrapper slider-component');
    if (!sc || sc.__piDots) return;
    var list = sc.querySelector('.product__media-list') || sc.querySelector('ul');
    if (!list) return;
    var slides = list.querySelectorAll('.product__media-item, li');
    var n = slides.length;
    if (n < 2) return;
    sc.__piDots = true;
    if (getComputedStyle(sc).position === 'static') sc.style.position = 'relative';
    var dots = document.createElement('div'); dots.className = 'pi-pdp-dots';
    for (var i=0;i<n;i++){ var d=document.createElement('span'); d.className='pi-pdp-dot'+(i===0?' is-active':''); dots.appendChild(d); }
    sc.appendChild(dots);
    var spans = dots.querySelectorAll('.pi-pdp-dot');
    function setActive(idx){ if(idx<0)idx=0; if(idx>n-1)idx=n-1; for(var j=0;j<spans.length;j++){ spans[j].classList.toggle('is-active', j===idx); } }
    var raf;
    function fromScroll(){ var w=list.clientWidth||1; setActive(Math.round(list.scrollLeft / w)); }
    list.addEventListener('scroll', function(){ if(raf)cancelAnimationFrame(raf); raf=requestAnimationFrame(fromScroll); }, {passive:true});
    sc.addEventListener('slideChanged', function(e){ if(e && e.detail && e.detail.currentPage) setActive(e.detail.currentPage-1); });
  }
  function piStickyAtc(){
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.pi-sticky-atc')) return;
    var form = document.querySelector('.product-form__buttons');
    var realBtn = form ? form.querySelector('.product-form__submit, button[name="add"], [type="submit"]') : null;
    if (!form || !realBtn) return;
    var titleEl = document.querySelector('.product__title h1') || document.querySelector('.product__title');
    var title = titleEl ? (titleEl.textContent||'').replace(/\s+/g,' ').trim() : '';
    var label = (realBtn.textContent||'').replace(/\s+/g,' ').trim() || 'Add to Cart';
    var bar = document.createElement('div'); bar.className='pi-sticky-atc is-ready';
    bar.innerHTML = '<span class="pi-sticky-atc__info"></span><button type="button" class="pi-sticky-atc__btn"></button>';
    bar.querySelector('.pi-sticky-atc__info').textContent = title;
    bar.querySelector('.pi-sticky-atc__btn').textContent = label;
    document.body.appendChild(bar);
    bar.querySelector('.pi-sticky-atc__btn').addEventListener('click', function(){
      if (realBtn.disabled){ var sel=document.querySelector('.product-form__input--pill'); if(sel) sel.scrollIntoView({behavior:'smooth', block:'center'}); return; }
      realBtn.click();
    });
    function onChange(visible){ if(visible){ bar.classList.remove('is-visible'); document.body.classList.remove('pi-atc-on'); } else { bar.classList.add('is-visible'); document.body.classList.add('pi-atc-on'); } }
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ onChange(en.isIntersecting); }); }, {threshold:0});
      io.observe(form);
    } else {
      window.addEventListener('scroll', function(){ var r=form.getBoundingClientRect(); onChange(r.bottom>0 && r.top<(window.innerHeight||0)); }, {passive:true});
    }
  }

  /* Mouse wheel over the New Arrivals row scrolls it sideways; at either end the page scrolls as normal. */
  window.addEventListener('wheel', function(e){
    var track = e.target && e.target.closest ? e.target.closest('.pi-feed__track') : null;
    if (!track || e.ctrlKey) return;
    var dx = e.deltaX, dy = e.deltaY;
    if (e.deltaMode === 1){ dx *= 16; dy *= 16; }
    if (Math.abs(dx) >= Math.abs(dy)) return; /* trackpad sideways swipe: native */
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 2) return;
    if ((dy > 0 && track.scrollLeft >= max - 1) || (dy < 0 && track.scrollLeft <= 0)) return;
    e.preventDefault();
    track.scrollLeft += dy;
  }, { capture: true, passive: false });

  (function(){
    function isHome(){ return document.body && document.body.classList.contains('template-index'); }
    ['wheel','touchmove'].forEach(function(evt){
      window.addEventListener(evt, function(e){ if (isHome()) e.stopImmediatePropagation(); }, { capture:true });
    });
  })();

  ready(function(){
    (function(){
      var menus = document.querySelectorAll('.menu-drawer__menu');
      if (!menus.length) return;
      var topMenu = null, subMenu = null;
      Array.prototype.forEach.call(menus, function(ul){
        if (Array.prototype.some.call(ul.children, function(li){ return /collaborations/i.test(li.textContent||''); })) topMenu = ul;
      });
      Array.prototype.forEach.call(menus, function(ul){
        if (ul===topMenu) return;
        if (ul.querySelector('a[href*="/collections/denim"], a[href*="/collections/tops"]')) subMenu = ul;
      });
      if (!topMenu || !subMenu) return;
      if (topMenu.querySelector('.pi-menu-heading')) return;
      var cats = Array.prototype.slice.call(subMenu.querySelectorAll('a')).map(function(a){
        return { t:(a.textContent||'').replace(/\s+/g,' ').trim(), href:a.getAttribute('href') };
      }).filter(function(c){ return c.t && c.href; });
      if (!cats.length) return;
      var hd=document.createElement('li'); hd.className='pi-menu-heading'; hd.setAttribute('role','presentation'); hd.textContent='Shop the Categories';
      topMenu.appendChild(hd);
      cats.forEach(function(c, idx){
        var li=document.createElement('li'); li.className='pi-cat-item';
        var a=document.createElement('a');
        a.className='menu-drawer__menu-item list-menu__item link link--text focus-inset pi-cat-link';
        a.href=c.href; a.textContent=c.t;
        li.appendChild(a);
        if (idx===cats.length-1) li.classList.add('pi-cat-last');
        topMenu.appendChild(li);
      });
    })();

    piColTabs();
    piSubscribeHook();
    piPromo();

    if (document.body.classList.contains('template-index')){
      var piHeroEnsure = function(){
        var host = null;
        document.querySelectorAll('.fullpage-section').forEach(function(s){ if (!host && s.id==='section1' && s.getBoundingClientRect().height>100) host=s; });
        if (!host) return;
        if (getComputedStyle(host).position==='static') host.style.position='relative';
        var ov = document.getElementById('pi-hero-ov');
        if (!ov){
          ov = document.createElement('div'); ov.id='pi-hero-ov'; ov.className='pi-hero-overlay';
          ov.innerHTML = '<h1 class="pi-hero-title">New Arrivals</h1><p class="pi-hero-sub">Crafted in limited runs. Made to last.</p><a class="pi-hero-cta" href="/collections/pearled-ivory">Shop Now <span aria-hidden="true">&#8594;</span></a>';
        }
        if (ov.parentElement !== host) host.appendChild(ov);
        ov.style.opacity = '1';
        var b = host.querySelector('a.btn'); if (b) b.style.display='none';
      };
      piHeroEnsure();
      setInterval(piHeroEnsure, 800);
      window.addEventListener('resize', piHeroEnsure);

      (function(){
        function injectFeeds(products){
          ['.mobile-sections','.desktop-sections'].forEach(function(sel){
            var wrap = document.querySelector(sel); if (!wrap) return;
            var lists = wrap.querySelectorAll('.fullpage-section-list');
            if (lists[0] && !lists[0].querySelector('.pi-feed')){ lists[0].innerHTML = piFeedHTML(products); lists[0].classList.add('pi-feed-host'); }
            if (lists[1]){
              if (!lists[1].querySelector('.pi-denim-video')){ lists[1].innerHTML = piDenimVideoHTML(); lists[1].style.display = ''; }
            } else if (lists[0] && !wrap.querySelector('.pi-denim-video')){
              var dh = document.createElement('div'); dh.className = 'fullpage-section pi-denim-host'; dh.innerHTML = piDenimVideoHTML();
              if (lists[0].parentNode) lists[0].parentNode.insertBefore(dh, lists[0].nextSibling);
            }
          });
          piWireFeed();
          piPlayDenim();
        }
        var piFeedCol = 'pearled-ivory'; /* always the New Arrivals collection, not the drop collection */
        fetch('/collections/'+piFeedCol+'/products.json?limit=250')
          .then(function(r){ return r.json(); })
          .then(function(d){
            if (!d || !d.products || !d.products.length) return;
            /* Same products, same order as the New Arrivals page (/collections/pearled-ivory, sorted manually in admin). */
            injectFeeds(d.products);
          })
          .catch(function(){});
      })();
    }

    if (/\/products\//.test(location.pathname)){
      var handle = location.pathname.split('/products/')[1].split('/')[0].split('?')[0];
      fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){
        if (p && p.type && !document.querySelector('.pi-eyebrow')){
          var t=document.querySelector('.product__title'); if(t){ var eb=document.createElement('div'); eb.className='pi-eyebrow'; eb.textContent=p.type; t.parentNode.insertBefore(eb,t); }
        }
      }).catch(function(){});
      if (!document.querySelector('.pi-ship-note')){
        var btns=document.querySelector('.product-form__buttons');
        if(btns){ var nn=document.createElement('p'); nn.className='pi-ship-note'; nn.textContent='Free Shipping, Duty Free for UK, AUS, & EU, and ships in 16 hours'; btns.parentNode.insertBefore(nn, btns.nextSibling); }
      }
      piPdpDots(); setTimeout(piPdpDots, 500); setTimeout(piPdpDots, 1500);
      piStickyAtc(); setTimeout(piStickyAtc, 600);
    }

    var types = window.__piCardTypes || {};
    document.querySelectorAll('.card-wrapper, .product-card-wrapper').forEach(function(card){
      if (card.querySelector('.pi-card-info')) return;
      var link = card.querySelector('a[href*="/products/"]'); if(!link) return;
      var href = link.getAttribute('href');
      var handle = href.split('/products/')[1].split('?')[0].split('/')[0];
      var titleText = '';
      card.querySelectorAll('a[href*="/products/"]').forEach(function(a){ var t=a.textContent.replace(/\s+/g,' ').trim(); if(!titleText && t.length>2) titleText=t; });
      var priceEl = card.querySelector('.price-item--regular') || card.querySelector('.price-item') || card.querySelector('.price');
      var priceText = priceEl ? priceEl.textContent.replace(/\s+/g,' ').trim() : '';
      var type = types[handle] || '';
      card.querySelectorAll('.card__information, .card-information').forEach(function(el){ el.style.display='none'; });
      var info = document.createElement('div'); info.className='pi-card-info';
      info.innerHTML = '<a class="pi-card-info__main" href="'+href+'">'+(type?'<span class="pi-card-eyebrow">'+type+'</span>':'')+'<span class="pi-card-title">'+titleText+'</span></a><span class="pi-card-price">'+priceText+'</span>';
      var inner = card.querySelector('.card__inner');
      if (inner && inner.parentNode) { inner.parentNode.insertBefore(info, inner.nextSibling); }
      else { card.appendChild(info); }
      var media = card.querySelector('.card__media') || inner;
      if (media && !card.querySelector('.pi-card-bag') && !(window.piIsLocked && window.piIsLocked(handle))){
        var b=document.createElement('button'); b.type='button'; b.className='pi-card-bag'; b.setAttribute('aria-label','Quick add');
        b.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
        media.appendChild(b);
        (function(hh){ b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); quickAdd(hh); }); })(handle);
      }
      if (media && !media.__piNav){
        media.__piNav = true; media.style.cursor = 'pointer';
        (function(hr){
          media.addEventListener('click', function(e){
            if (e.target && e.target.closest && e.target.closest('.pi-card-bag, button, a, .swiper-pagination, .swiper-button-next, .swiper-button-prev, [class*="pagination"], [class*="swiper-button"]')) return;
            if (hr) location.href = hr;
          });
        })(href);
      }
      var hm = card.querySelector('.card__media .media');
      if (hm && !hm.classList.contains('pi-hover-bg')){
        var himgs = Array.prototype.slice.call(hm.querySelectorAll('img'));
        if (himgs.length >= 2){
          var hp = himgs[0];
          var hpf = (hp.currentSrc||hp.src||'').split('?')[0];
          var hs = null;
          for (var hi=1; hi<himgs.length; hi++){ var hf=(himgs[hi].currentSrc||himgs[hi].src||'').split('?')[0]; if(hf && hf!==hpf){ hs=himgs[hi]; break; } }
          if (hs){
            var hurl = piPickSrc(hs, 600);
            himgs.forEach(function(im){ if(im!==hp) im.style.display='none'; });
            hp.classList.add('pi-img-primary');
            hm.classList.add('pi-hover-bg');
            hm.style.backgroundImage = 'url("'+hurl+'")';
          }
        }
      }
    });
  });
})();
